import { useContext } from 'react';
import Box from '@mui/material/Box';
import HelpIcon from '@mui/icons-material/HelpOutline';
import Typography from '@mui/material/Typography';
import dayjs from 'helpers/dayjs';

import { CardContext } from 'context/cards/cardContext';
import { numberFormat } from 'helpers/i18n';
import WhiteTooltip from 'components/shared/Tooltips/WhiteTooltip';
import BlueToolTip from 'components/shared/BlueTooltip';
import Logo03 from 'assets/overviewSection/PS-Logo03.svg';

const PrepaidModelOverview = () => {
    const { statistics } = useContext(CardContext);

    return (
        <Box
            display="flex"
            sx={{
                flexDirection: {
                    md: 'row',
                    xs: 'column'
                }
            }}>
            <Box
                className="statistic-card background-color-main"
                sx={{
                    backgroundImage: `url(${Logo03})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: '-23% 50%'
                }}>
                <Box className="statistic-card-info">
                    <Typography className="statistic-title white-text">
                        DeFi Account Balance
                        <WhiteTooltip
                            placement="top"
                            arrow
                            title={
                                <Typography className="tooltip-stat-text black-text">
                                    This is the amount you can spend across all active cards
                                </Typography>
                            }>
                            <HelpIcon sx={{ color: 'white', fontSize: '12px', marginLeft: '5px' }} />
                        </WhiteTooltip>
                    </Typography>
                    <Typography className="statistic-value white-text">
                        {numberFormat(statistics.accountBalance, 2, 2)}
                    </Typography>
                </Box>
            </Box>
            <Box className="statistic-card background-color-white">
                <Box className="statistic-card-info">
                    <Typography className="statistic-title gray-text">
                        Available to add to cards
                        <BlueToolTip
                            placement="top"
                            arrow
                            title={
                                <Typography className="tooltip-stat-text white-text font-weight-bold">
                                    This is the amount you have available to add to new or existing cards.
                                </Typography>
                            }>
                            <HelpIcon sx={{ color: '#617380', fontSize: '12px', marginLeft: '5px' }} />
                        </BlueToolTip>
                    </Typography>
                    <Typography className="statistic-value black-text">
                        {numberFormat(statistics.availableToAddtoCards, 2, 2)}
                    </Typography>
                </Box>
            </Box>
            <Box className="statistic-card background-color-white">
                <Box className="statistic-card-info">
                    <Box display="flex" justifyContent="space-between">
                        <Typography className="statistic-title gray-text">
                            Total Spent
                            <BlueToolTip
                                placement="top"
                                arrow
                                title={
                                    <Typography className="tooltip-stat-text white-text font-weight-bold">
                                        This is the amount you've spent during the current month.
                                    </Typography>
                                }>
                                <HelpIcon sx={{ color: '#617380', fontSize: '12px', marginLeft: '5px' }} />
                            </BlueToolTip>
                        </Typography>
                        <Typography className="total-amount-spent-date">{dayjs().format('MMM, YYYY')}</Typography>
                    </Box>
                    <Typography className="statistic-value black-text">
                        {numberFormat(statistics.totalAmountSpentInCurrentMonth, 2, 2)}
                    </Typography>
                </Box>
            </Box>
            <Box className="statistic-card background-color-white">
                <Box className="statistic-card-info">
                    <Typography className="statistic-title gray-text">Active | Zero Balance Cards</Typography>
                    <Box sx={{ display: 'flex' }}>
                        <Typography className="statistic-value black-text" sx={{ marginRight: '8px' }}>
                            {statistics.activeCards}
                        </Typography>
                        <Typography sx={{ fontSize: '18px', color: 'gray' }}> | </Typography>
                        <Typography
                            className="statistic-value red-text"
                            sx={{ marginLeft: '8px', color: statistics.zeroBalanceCards > 0 ? 'red' : 'black' }}>
                            {statistics.zeroBalanceCards}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>
    );
};

export default PrepaidModelOverview;
